export default function sortableObjectArrayBySku(skus, objArray) {
  if (!skus.length) return objArray

  const sortable = skus.map((sku) => objArray.find((obj) => obj.sku === sku))
  const rest = objArray.filter((obj) => !skus.includes(obj.sku))

  return [...sortable, ...rest].filter((mb) => !!mb)
}
